class AtcSection extends HTMLElement {
    connectedCallback() {
        this.currentUrl            = this.dataset.currentUrl || '';
        this.templateSuffix        = this.dataset.templateSuffix || '';
        this.landingTags           = this.dataset.landingTags || '';
        this.hydrationEnabled      = this.dataset.hydrationEnabled === 'true';
        this.promoRemovesHydration = this.dataset.promoRemovesHydration === 'true';
        this.hydrationMin          = Number(this.dataset.hydrationMin) || 0;
        this.sectionCustomAttr     = this.dataset.sectionCustomAttribute || '';
        this.settingsCustomAttr    = this.dataset.settingsCustomAttribute || '';
        this.productDiscount       = this.dataset.productDiscount || '';
        this.pageHandle            = this.dataset.pageHandle || '';
        this.cartPromo             = this.dataset.cartPromo || '';

        this._init();
    }

    disconnectedCallback() {
        this._teardown();
    }

    _init() {
        if (this._initialized) return;
        this._initialized = true;

        this._onFormatClick        = this.handleFormatClick.bind(this);
        this._onFlavorClick        = this.handleFlavorClick.bind(this);
        this._onAccordionToggle    = this.handleAccordionToggle.bind(this);
        this._onOfferClick         = this.handleOfferClick.bind(this);
        this._onQuantityClick      = this.handleQuantityClick.bind(this);
        this._onDiscountBoxClick   = this.handleDiscountBoxClick.bind(this);
        this._onAtcClick           = this.handleAtcClick.bind(this);
        this._onOneTimePurchase    = this.handleOneTimePurchase.bind(this);
        this._onResize             = this._handleResize.bind(this);

        this.setFormatListeners();
        this.setFlavorListeners();
        this.setAccordionListeners();
        this.setOfferListeners();
        this.setQuantityListeners();
        this.setAtcListeners();
        this.setOneTimePurchaseListeners();
        this.initCarousel();
        this.initScrollArrow();
    }

    setFormatListeners() {
        this.querySelectorAll('.atc-product-variant-option').forEach(format => {
            format.addEventListener('click', this._onFormatClick);
        });
    }

    async handleFormatClick(e) {
        const format = e.currentTarget;
        const href = format.dataset.href;
        if (!href) return;
        this.swapSectionFromUrl(href, this.querySelectorAll('.atc-product-variant-option'));
    }

    setFlavorListeners() {
        this.querySelectorAll('.atc-product-option a').forEach(link => {
            link.addEventListener('click', this._onFlavorClick);
        });
    }

    handleFlavorClick(e) {
        const href = e.currentTarget.getAttribute('href');
        if (!href) return;
        e.preventDefault();
        this.swapSectionFromUrl(href, this.querySelectorAll('.atc-product-option'));
    }

    async swapSectionFromUrl(href, optionsToDisable) {
        const target = new URL(href, window.location.origin);
        if (target.pathname === window.location.pathname) return;
        if (this._sectionSwapInFlight) return;
        this._sectionSwapInFlight = true;

        (optionsToDisable || []).forEach(opt => opt.style.pointerEvents = 'none');
        this.classList.add('is-loading');

        try {
            const res = await fetch(href);
            if (!res.ok) throw new Error(`Failed to fetch ${href}: ${res.status}`);
            const html = await res.text();
            const newSection = new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector('atc-section');
            if (!newSection) throw new Error(`No atc-section found in ${href}`);
            this.replaceWith(newSection);
        } catch (err) {
            console.error('[ATC section swap]', err);
            window.location.href = href;
        }
    }









    setAccordionListeners() {
        this.querySelectorAll('.atc-section__accordion details').forEach(detail => {
            detail.addEventListener('toggle', this._onAccordionToggle);
        });
    }

    handleAccordionToggle(e) {
        const detail = e.currentTarget;
        if (!detail.open) return;
        this.querySelectorAll('.atc-section__accordion details').forEach(other => {
            if (other !== detail) other.removeAttribute('open');
        });
    }

    setOfferListeners() {
        this.querySelectorAll('.atc-section__offer').forEach(offer => {
            offer.addEventListener('click', this._onOfferClick);
        });
        this._updateOrder2SaveLabel();
    }

    _updateOrder2SaveLabel(activeOffer) {
        const offer = activeOffer || this.querySelector('.atc-section__offer.active');
        if (!offer) return;
        const amountSpan = offer.querySelector('.atc-section__offer-header-discount-amount');
        const pct = amountSpan ? amountSpan.dataset.double.replace(/[^0-9.]/g, '') : null;
        if (!pct) return;
        const label = this.querySelector('.atc-order2-save-pct');
        if (label) label.textContent = pct;
    }

    handleOfferClick(e) {
        const clicked = e.currentTarget;

        this.querySelectorAll('.atc-section__offer').forEach(o => {
            const isClicked = o === clicked;
            const wasActive = o.classList.contains('active');
            const radio = o.querySelector('input[type="radio"]');

            if (isClicked && !wasActive) {
                o.classList.add('active');
                if (radio) { radio.classList.add('active'); radio.checked = true; }
            } else if (!isClicked && wasActive) {
                o.classList.remove('active');
                if (radio) { radio.classList.remove('active'); radio.checked = false; }
            }
        });

        this._updateOrder2SaveLabel(clicked);
    }

    setQuantityListeners() {
        this.querySelectorAll('.atc-product-quantity__boxes').forEach(boxes => {
            const pill = document.createElement('div');
            pill.className = 'atc-product-quantity__pill';
            boxes.prepend(pill);

            const active = boxes.querySelector('.atc-product-quantity__box.active');
            if (active) this._movePill(pill, boxes, active, false);

            const container = boxes.closest('.atc-product-qauntity');
            if (active && container) this._syncDiscountBox(container, active.dataset.amount);
            if (active) this._syncQuantityValues(active.dataset.amount);

            const discountBox = container?.querySelector('.atc-product-quantity__discount-box');
            if (discountBox) discountBox.addEventListener('click', this._onDiscountBoxClick);

            boxes.addEventListener('click', this._onQuantityClick);
        });
    }

    _movePill(pill, boxes, box, animate = true) {
        if (!animate) pill.style.transition = 'none';
        const cr = boxes.getBoundingClientRect();
        const br = box.getBoundingClientRect();
        pill.style.width = br.width + 'px';
        pill.style.transform = `translateX(${br.left - cr.left - 6}px)`;
        if (!animate) {
            pill.offsetHeight;
            pill.style.transition = '';
        }
    }

    _activateQuantityBox(boxes, box) {
        if (box.classList.contains('active')) return;
        const pill = boxes.querySelector('.atc-product-quantity__pill');
        boxes.querySelectorAll('.atc-product-quantity__box').forEach(b => {
            b.classList.toggle('active', b === box);
        });
        if (pill) this._movePill(pill, boxes, box);
        const container = boxes.closest('.atc-product-qauntity');
        if (container) this._syncDiscountBox(container, box.dataset.amount);
        this._syncQuantityValues(box.dataset.amount);
    }

    _syncQuantityValues(amount) {
        const useDouble = amount === '2';

        this.querySelectorAll('[data-single]').forEach(el => {
            const val = useDouble ? el.dataset.double : el.dataset.single;
            if (!val) return;

            const amountSpan = el.querySelector('.offer-amount');
            if (amountSpan) {
                amountSpan.textContent = val;
            } else if (el.dataset.format === 'text') {
                el.textContent = val;
            } else if (el.classList.contains('atc-section__offer-monthly')) {
                el.textContent = `$${val}/mo`;
            } else if (el.classList.contains('atc-section__offer-daily')) {
                el.textContent = `$${val}/day`;
            } else if (el.classList.contains('atc-section__offer-header-discount-amount')) {
                el.textContent = `${val}`;
            } else {
                el.textContent = `$${val}`;
            }
        });
    }

    _syncDiscountBox(container, amount) {
        const discountBox = container.querySelector('.atc-product-quantity__discount-box');
        if (discountBox) discountBox.classList.toggle('active', amount === '2');
    }

    handleQuantityClick(e) {
        const box = e.target.closest('.atc-product-quantity__box');
        if (!box) return;
        const boxes = box.closest('.atc-product-quantity__boxes');
        this._activateQuantityBox(boxes, box);
    }

    handleDiscountBoxClick(e) {
        const container = e.currentTarget.closest('.atc-product-qauntity');
        const boxes = container?.querySelector('.atc-product-quantity__boxes');
        if (!boxes) return;
        const box2 = boxes.querySelector('[data-amount="2"]');
        if (box2) this._activateQuantityBox(boxes, box2);
    }

    initCarousel() {
        if (typeof Swiper === 'undefined') {
            window.addEventListener('load', () => this.initCarousel(), { once: true });
            return;
        }
        this._thumbWasVertical = window.innerWidth >= 1280;
        this._initThumbSlider();
        this._initMediaSlider();
        window.addEventListener('resize', this._onResize);
    }

    _initThumbSlider() {
        const el = this.querySelector('.atc-section__slider-thumb');
        if (!el) return;

        this._thumbSlider = new Swiper(el, {
            direction: window.innerWidth >= 1280 ? 'vertical' : 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 6,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: this.querySelector('.atc-thumb__nav-btn--next'),
                prevEl: this.querySelector('.atc-thumb__nav-btn--prev'),
            },
            breakpoints: {
                1440: { spaceBetween: 9 },
            },
        });
    }

    _initMediaSlider() {
        const el = this.querySelector('.atc-section__slider');
        if (!el) return;

        this._mediaSlider = new Swiper(el, {
            spaceBetween: 10,
            thumbs: { swiper: this._thumbSlider },
        });
    }

    _handleResize() {
        const isVertical = window.innerWidth >= 1280;
        if (isVertical === this._thumbWasVertical) return;
        this._thumbWasVertical = isVertical;
        this._thumbSlider?.destroy(true, true);
        this._mediaSlider?.destroy(true, true);
        this._initThumbSlider();
        this._initMediaSlider();
    }

    setAtcListeners() {
        this.querySelectorAll('.js-radio-subscription-add-to-cart').forEach(btn => {
            btn.addEventListener('click', this._onAtcClick);
        });
    }

    setOneTimePurchaseListeners() {
        this.querySelectorAll('.one-time-purchase').forEach(link => {
            link.addEventListener('click', this._onOneTimePurchase);
        });
    }

    async handleOneTimePurchase(e) {
        e.preventDefault();
        const link = e.currentTarget;
        const variantId = link.dataset.id;
        if (!variantId || link.dataset.adding) return;

        const properties = this._buildLineItemProperties(0);
        const productDescription = link.dataset.productDescription;
        if (productDescription) properties['_product_description'] = productDescription;
        const savings30 = link.dataset.savings;
        if (savings30) properties['_savings'] = savings30;

        const savingsPrice30 = parseFloat(link.dataset.savingsPrice).toFixed(2)
        if(savingsPrice30) properties['_savings_price'] = savingsPrice30

        const body = { id: variantId, quantity: 1 };
        if (Object.keys(properties).length) body.properties = properties;

        link.dataset.adding = '1';
        const originalText = link.innerHTML;
        link.textContent = 'Adding...';

        try {
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            });
            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.description || 'Cart add failed');
            }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added:event', {}));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {}));
        } catch (err) {
            console.error('[OTP]', err);
        } finally {
            console.log(link)
            console.log(originalText)
            delete link.dataset.adding;
            link.textContent = originalText;
        }
    }

    async handleAtcClick(e) {
        const btn = e.currentTarget;
        if (btn.disabled) return;

        const activeOffer = this.querySelector('.atc-section__offer.active');
        if (!activeOffer) return;

        const input = activeOffer.querySelector('input[data-variant-id]');
        if (!input) return;

        const variantId = input.dataset.variantId;
        const sellingPlan = input.dataset.plan;
        const price = Number(input.dataset.price) || 0;
        const quantity = parseInt(this.querySelector('.atc-product-quantity__box.active')?.dataset.amount || '1', 10);

        const body = { id: variantId, quantity };
        if (sellingPlan) body.selling_plan = sellingPlan;

        const properties = this._buildLineItemProperties(price);
        const productDescription = input.dataset.productDescription;
        if (productDescription) properties['_product_description'] = productDescription;
        const savings = input.dataset.savings;
        if (savings) properties['_savings'] = savings;
        if (Object.keys(properties).length) body.properties = properties;

        btn.disabled = true;
        const originalHtml = btn.innerHTML;
        btn.innerHTML = '<span>Adding...</span>';

        try {
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            });
            if (!res.ok) {
                const err = await res.json();
                throw new Error(err.description || 'Cart add failed');
            }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added:event', {

            }));

            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {

            }));
        } catch (err) {
            console.error('[ATC]', err);
            btn.disabled = false;
            btn.innerHTML = originalHtml;
        }finally{
            btn.disabled = false;
            btn.innerHTML = originalHtml;
        }
    }

    _buildLineItemProperties(price) {
        const props = {};

        // 1. TBN landing-page channel tag or fallback; non-TBN uses localStorage order-tag
        if (this.templateSuffix.includes('tbn')) {
            const urlParams = new URLSearchParams(window.location.search);
            const channel = urlParams.get('channel');
            if (channel && this.landingTags) {
                const tagSettingsArr = this.landingTags.split(';');
                const match = tagSettingsArr.find(item => item.split('//')[0].trim() === channel);
                if (match) {
                    match.split('//')[1].trim().split('\n').forEach(item => {
                        const [k, v] = item.split(':');
                        if (k && v !== undefined) props[k] = v.trim();
                    });
                } else {
                    props['_order_tag'] = 'VTBNWEB';
                }
            } else {
                props['_order_tag'] = 'VTBNWEB';
            }
        } else {
            const orderTag = localStorage.getItem('order-tag');
            if (orderTag) {
                orderTag.split('//').forEach(item => {
                    const [k, v] = item.split(':');
                    if (k && v !== undefined) props[k] = v.trim();
                });
            }
        }

        // 2. Client ID
        const cid = localStorage.getItem('cid');
        if (cid) props['_cid'] = cid;

        // 3. Promo (price threshold matches hydration min)
        const promo = sessionStorage.getItem('promo');
        if (promo && price >= this.hydrationMin) {
            props['_promo'] = promo;
        }

        // 4. Free hydration custom attribute
        if (this.hydrationEnabled && !this.promoRemovesHydration && price >= this.hydrationMin) {
            if (this.sectionCustomAttr) {
                const [k, v] = this.sectionCustomAttr.split(':');
                if (k && v !== undefined) props[k] = v.trim();
            }
            if (this.settingsCustomAttr) {
                const [k, v] = this.settingsCustomAttr.split(':');
                if (k && v !== undefined) props[k] = v.trim();
            }
        }

        // 5. End-of-year deal (capsules page only)
        if (this.templateSuffix === 'capsules' && sessionStorage.getItem('eoy')) {
            props['_eoy'] = 'deal';
        }

        // 6. Cart attribute promo override
        if(this.cartPromo == ''){
            let promoFlag = sessionStorage.getItem('promoFlag')
            if (promoFlag){ this.cartPromo = promoFlag}
        }
        if (this.cartPromo === 'wb26g') {
            props['_promo'] = 'wb26g';
        }

        if (this.cartPromo === 'ac') {
            props['_promo'] = 'ac';
        }

        return props;
    }

    _teardown() {
        this.querySelectorAll('.atc-product-variant-option').forEach(format => {
            format.removeEventListener('click', this._onFormatClick);
        });
        this.querySelectorAll('.atc-product-option a').forEach(link => {
            link.removeEventListener('click', this._onFlavorClick);
        });
        this.querySelectorAll('.atc-section__accordion details').forEach(detail => {
            detail.removeEventListener('toggle', this._onAccordionToggle);
        });
        this.querySelectorAll('.atc-section__offer').forEach(offer => {
            offer.removeEventListener('click', this._onOfferClick);
        });
        this.querySelectorAll('.atc-product-quantity__boxes').forEach(boxes => {
            boxes.removeEventListener('click', this._onQuantityClick);
        });
        this._thumbSlider?.destroy(true, true);
        this._mediaSlider?.destroy(true, true);
        window.removeEventListener('resize', this._onResize);
        this.querySelectorAll('.atc-product-quantity__discount-box').forEach(db => {
            db.removeEventListener('click', this._onDiscountBoxClick);
        });
        this.querySelectorAll('.js-radio-subscription-add-to-cart').forEach(btn => {
            btn.removeEventListener('click', this._onAtcClick);
        });
        this.querySelectorAll('.one-time-purchase').forEach(link => {
            link.removeEventListener('click', this._onOneTimePurchase);
        });
        this._scrollArrowRight?.removeEventListener('click', this._onArrowRightClick);
        this._scrollArrowLeft?.removeEventListener('click', this._onArrowLeftClick);
        this._optionsScroller?.removeEventListener('scroll', this._onOptionsScroll);
    }

    initScrollArrow() {
        this._scrollArrowRight = this.querySelector('.atc-scroll-arrow:not(.atc-scroll-arrow--left)');
        this._scrollArrowLeft  = this.querySelector('.atc-scroll-arrow--left');
        this._optionsScroller  = this.querySelector('.atc-product-options');
        if (!this._optionsScroller) return;

        const getItemWidth = () =>
            (this._optionsScroller.querySelector('.atc-product-option')?.offsetWidth || 100) + 8;

        this._onArrowRightClick = () => {
            this._optionsScroller.scrollLeft += getItemWidth();
        };

        this._onArrowLeftClick = () => {
            this._optionsScroller.scrollLeft -= getItemWidth();
        };

        this._onOptionsScroll = () => {
            const el  = this._optionsScroller;
            const atStart = el.scrollLeft <= 4;
            const atEnd   = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
            this._scrollArrowLeft?.classList.toggle('visible', !atStart);
            this._scrollArrowRight?.classList.toggle('visible', !atEnd);
        };

        this._scrollArrowRight?.addEventListener('click', this._onArrowRightClick);
        this._scrollArrowLeft?.addEventListener('click', this._onArrowLeftClick);
        this._optionsScroller.addEventListener('scroll', this._onOptionsScroll);

        requestAnimationFrame(() => {
            const el = this._optionsScroller;
            if (el.scrollWidth > el.clientWidth) {
                this._scrollArrowRight?.classList.add('visible');
            }
        });
    }
}

customElements.define('atc-section', AtcSection);